export {
  default
}
from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-image/index.js